export const PLACEMENT_TO_TEXT_POSITION_MAP = {
  START: 'left',
  CENTER: 'center',
  END: 'right'
};
export const PLACEMENT_TO_FLEX_MAP = {
  START: 'flex-start',
  CENTER: 'center',
  END: 'flex-end'
};
//# sourceMappingURL=consts.js.map